<template>
	<el-dialog title="上传附件" class="uploaderDialog" v-if="dialogVisible" :visible.sync="dialogVisible" width="550px" @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
		<uploader v-loading="loading"
		          element-loading-text="文件较大请稍后"
		          element-loading-spinner="el-icon-loading"
		          ref="uploader" :options="uploaderOptions" :autoStart="false"
		          :file-status-text="statusText"
		          @file-added="fileAdded"
		          @file-success="handleUploadSuccess"
		          @file-progress="onFileProgress">
			<uploader-unsupport></uploader-unsupport>
			<uploader-drop>
				<uploader-btn class="el-upload-dragger">
					<i class="el-icon-upload"></i><br/>
					将文件拖到此处，或 <span>点击上传</span>
				</uploader-btn>
			</uploader-drop>
			<p class="el-upload__tip">仅支持上传一份文件，格式不限，文件最大500MB</p>
			<uploader-list v-show="panelShow"></uploader-list>
		</uploader>
	</el-dialog>
</template>

<script>
    import axios from 'axios'
    import CryptoJS from "crypto-js"

    export default {
        props: ['show'],
        data() {
            return {
                dialogVisible: false,
                loading: false,
                // uploader组件文件上传参数
                uploaderOptions: {
                    target: this.config_env.BASE_URL + '/api/file/chunk',
                    singleFile: true,
                    chunkSize: '1048576',
                    simultaneousUploads: 5,
                    checkChunkUploadedByResponse: this.checkChunkUploadedByResponse,
                    withCredentials: true,  // 携带cookie
                    parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
                        return parsedTimeRemaining
                            .replace(/\syears?/, '年')
                            .replace(/\days?/, '天')
                            .replace(/\shours?/, '小时')
                            .replace(/\sminutes?/, '分钟')
                            .replace(/\sseconds?/, '秒')
                    },
                },
                statusText: {
                    success: '合并中',
                    error: '上传失败',
                    uploading: '上传中',
                    paused: '暂停中',
                    waiting: '等待中'
                },
                // uploader组件上传证书附件文件类型限制
                // attrs: {
                //     accept: '.jpg, .jpeg, .png'
                // },
                // uploader组件文件上传校验
                validateFile: {
                    accept: '*',
                    limit: 1,
                    totalSize: 500,
                    tip: '可上传1个文件，总大小不超过10MB'
                },
                // 附件文件Id
                attachmentFileId: '',
                // 附件文件上传对象
                files: [],
                // 附件名称输入类型：选择框/输入框
                nameInputType: true,
                panelShow: false,   //选择文件后，展示上传panel
                collapse: true
            };
        },
        watch: {
            show() {
                this.dialogVisible = this.show;
                this.loading = false
            }
        },
        methods: {
            /** 预览附件照片*/
            previewPictures(file) {
                return window.URL.createObjectURL(file.file);
            },
            deleteAttachment() {
                if (this.form.attachment) {
                    this.form.attachment = '';
                }
            },
            deleteAttachmentFile(i) {
                this.files.splice(i, 1);
            },
            fileAdded(file) {
                const uploader = this.$refs.uploader.uploader;
                const limit = this.validateFile.limit;
                const maxSize = this.validateFile.totalSize;
                const accept = this.validateFile.accept;
                const already = uploader.files.find(x => x.name === file.name);
                if (already) {
                    file.ignored = true;
                    this.$message.error('请不要重复上传相同文件');
                    file.cancel()
                    return;
                }
                if (accept !== '*' && accept.indexOf(file.name.substring(file.name.lastIndexOf('.'))) === -1) {
                    console.log(accept.indexOf(file.name.substring(file.name.lastIndexOf('.'))));
                    file.ignored = true;
                    this.$message.error(`文件格式不符合要求，请上传${accept}格式文件`);
                    return;
                }
                if (uploader.files.length >= limit) {
                    file.ignored = true;
                    this.$message.error(`上传的文件总数不能大于${limit}`);
                    return;
                }
                if (file.size / 1024 / 1024 > maxSize) {
                    file.ignored = true;
                    this.$message.error(`文件大小不能超过${this.validateFile.totalSize}MB`);
                    return;
                }
                if (file.size / 1024 / 1024 > 10) {
                    this.loading = true
                }

                this.sha256(file);
            },
            /** 文件转sha256 */
            sha256(file) {
                let _this = this
                let contractFile = file.file;
                let reader = new FileReader()
                let blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice;
                let chunkSize = 6 * 1024 * 1024;
                let chunks = Math.ceil(contractFile.size / chunkSize);
                let currentChunk = 0;
                let hasher = CryptoJS.algo.SHA256.create();
                let start = currentChunk * chunkSize;
                let end = start + chunkSize >= contractFile.size ? contractFile.size : start + chunkSize;
                reader.readAsArrayBuffer(blobSlice.call(contractFile, start, end));
                reader.onload = function (evt) {
                    // let wordArray = CryptoJS.lib.WordArray.create(reader.result);
                    let fileStr = evt.target.result;
                    let tmpWordArray = _this.arrayBufferToWordArray(fileStr);
                    hasher.update(tmpWordArray);
                    currentChunk += 1;
                    fileStr = null;
                    tmpWordArray = null;
                    if (currentChunk * chunkSize < contractFile.size) {
                        let start = currentChunk * chunkSize;
                        let end = start + chunkSize >= contractFile ? contractFile.size : start + chunkSize;
                        reader.readAsArrayBuffer(blobSlice.call(contractFile, start, end));
                        console.log('校验MD5 ' + ((currentChunk / chunks) * 100).toFixed(0) + '%')
                    } else {
                        reader.onloadend = function () {
                            contractFile = null;
                            let hash = hasher.finalize();
                            hash.toString();//计算结果
                            // axios.post(_this.config_env.BASE_URL + '/api/file/checkAndGetUriBySha256/' + hash, file, {withCredentials: true}).then(function (res) {
                                _this.loading = false
                                _this.panelShow = true;
                                hasher = null;
                                blobSlice = null;
                                reader = null;
                                hash = null;
                                // if (res.data.status === 200) {
                                //     if (res.data.data) {
                                //         // 已存在，无需重复上传
                                //         _this.$emit('close', {
                                //             file_name: file.name,
                                //             file_md5: res.data.data.md5,
                                //             file_path: res.data.data.uri
                                //         })
                                //         _this.$message.success('上传成功');
                                //     } else {
                                        // 文件不存在，可以上传
                                        console.log("文件不存在，可以上传")
                                        // 手动开始文件上传
                                        file.resume();
                                //     }
                                // } else if (res.data.status === 500) {
                                //     _this.$message.success(res.data.message);
                                // }
                            // })
                        }
                    }
                }
            },
            arrayBufferToWordArray(ab) {
                var i8a = new Uint8Array(ab);
                var a = [];
                for (var i = 0; i < i8a.length; i += 4) {
                    a.push(i8a[i] << 24 | i8a[i + 1] << 16 | i8a[i + 2] << 8 | i8a[i + 3]);
                }
                return CryptoJS.lib.WordArray.create(a, i8a.length);
            },
            /** 分块文件上传*/
            checkChunkUploadedByResponse(chunk, message) {
                let res = JSON.parse(message);
                if (Array.isArray(res.data)) {
                    let chunkNumbers = res.data;
                    return (chunkNumbers || []).indexOf(chunk.offset + 1) >= 0;
                } else {
                    if (null === res.data) {
                        return false;
                    } else {
                        chunk.file.itemId = res.data;
                        console.log(chunk.file.itemId);
                        return true;
                    }
                }
            },
            /** 分块文件上传完毕，合并分块文件，返回文件id*/
            async handleUploadSuccess(rootFile, file, message, chunk) {
                let res = JSON.parse(message);
                if (res.data && res.data === true) {
                    console.log('分块上传完成，开始合并...')
                    let _this = this
                    axios.post(_this.config_env.BASE_URL + '/api/file/merge', file, {withCredentials: true}).then(function (res) {
                        // this.form.fileId = res.data.data.fileId;
                        if (res.data.status === 200) {
                            _this.$emit('close', {
                                file_name: file.name,
                                file_md5: res.data.data.md5,
                                file_path: res.data.data.uri
                            })
                            _this.$message.success('上传成功');
                        } else if (res.data.status === 500) {
                            _this.$emit('close', {
                                file_name: '',
                                file_md5: '',
                                file_path: ''
                            })
                            _this.$message.success(res.data.message);
                        }
                        // this.files = _this.$refs.uploader.files;
                    })
                }
            },
            // 文件进度的回调
            onFileProgress(rootFile, file, chunk) {
                console.log(`上传中 pom.xml，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
            },
            onFileError(rootFile, file, response, chunk) {
                console.log(error)
            },
            close() {
                this.dialogVisible = false
                this.$emit('update:show', false)
            },
        }
    }
</script>

<style scoped>
	.uploaderDialog >>> .el-dialog {
		padding-bottom: 20px;
	}

	.el-upload__tip {
		text-align: center;
		margin-bottom: 10px;
	}

	.uploader-drop {
		border: 1px dashed #d9d9d9 !important;
		background: #fff !important;
		border-radius: 6px;
		text-align: center;
		padding: 0 !important;
		margin-bottom: 10px;
		height: 170px;
	}

	.uploader-drop:hover {
		border-color: #0070de !important;
	}

	.uploader-drop .uploader-btn {
		border: 0 !important;
		width: 100% !important;
		height: 100% !important;
	}

	.uploaderDialog .uploader-btn:hover {
		background-color: #fff;
	}

	.uploaderDialog .uploader-btn span {
		color: #0070de;
	}

	.uploaderDialog >>> .uploader-file-info {
		font-size: 13px;
	}

	.uploaderDialog >>> .uploader-file-icon {
		width: 14px !important;
		margin-top: 18px !important;
	}

	.uploaderDialog >>> .uploader-file-icon:before {
		font-size: 14px !important;
	}

	.uploaderDialog >>> .uploader-file-name {
		width: 40% !important;
	}

	.uploaderDialog >>> .uploader-file-meta {
		display: none;
	}

	.uploaderDialog >>> .uploader-file-status {
		width: 36% !important;
	}

	.uploaderDialog >>> .uploader-file-actions {
		width: 11% !important;
	}
</style>
